<app-modal-dialog [show]="showModal" size="auto" position="center" #modal>
    <div class="modal-header" modal-header>
        <h3>Órdenes</h3>
        <h3 style="left: 0" class="i-hover">
            <i class="fa fa-xmark" (click)="closeModal(modal)"></i>
        </h3>
    </div>

    <div class="modal-body" modal-body>
        <div class="d-flex flex-col">
            <span class="font-bold">{{ startDate | date:'dd/MM/YYYY' }} - {{ endDate | date:'dd/MM/YYYY' }}</span>
            <span class="font-semibold">{{productName}}</span>
        </div>
        <div class="d-flex flex-col" *ngIf="!loading">
            <span>No. Órdenes</span>
            <ng-container *ngFor="let item of details">
                <span class="fc-daygrid-event event">#{{ item.number }} - {{item.providerData.name}}</span>
            </ng-container>
        </div>
        <div class="d-flex flex-col justify-center text-center" *ngIf="loading">
            <app-loading-animation [height]="'3rem'"/>
            Cargando...
        </div>
    </div>

</app-modal-dialog>